module.exports = __webpack_public_path__ + "img/product26.3646c8c0.png";